import { render, staticRenderFns } from "./matchingdata.vue?vue&type=template&id=e5b26208&scoped=true&"
import script from "./matchingdata.vue?vue&type=script&lang=js&"
export * from "./matchingdata.vue?vue&type=script&lang=js&"
import style0 from "./matchingdata.vue?vue&type=style&index=0&id=e5b26208&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5b26208",
  null
  
)

export default component.exports